import { PlayOnePagerLoading } from "@softmax/product-ux/play";

export function PlayPending() {
  return <PlayOnePagerLoading accent="#945637" />;
}
